var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-63e40189-22a9-4a6f-bf60-dbc74d42203e",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 15 15",
    style: {
      enableBackground: "new 0 0 15 15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.86;}\n\t.st1{fill:#1D4927;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-9e95af51-e85b-43e9-9f16-5b8e26493ebe"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-39eabdba-9084-4a1d-a5a7-1d4ebbc50558",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.9,13.2c0.4,0,0.6-0.1,0.9-0.3c1.6-1.4,3.3-3,4.9-4.4c0.6-0.6,0.6-1.1,0-1.7c-1-0.9-2-1.8-2.8-2.7 C8.1,3.4,7.4,2.8,6.6,2.2C6.2,1.6,5.2,1.7,4.9,2.4c-0.1,0.4,0,0.8,0.4,1.1C6.6,4.8,8,6.1,9.5,7.4c0.1,0.1,0.1,0.2,0,0.3 c-1.1,1-2.2,2-3.3,3c-0.4,0.3-0.7,0.7-1.1,1c-0.2,0.3-0.2,0.7-0.1,1C5.2,13,5.5,13.2,5.9,13.2L5.9,13.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.439ae3c813826145cc9f919d0be5bcad.svg";
export { ForwardRef as ReactComponent };